export const page = async () => {
	// Ranking
    datosRanking();
}

function datosRanking() {
    try {
        let url = window.location.protocol+`//`+window.location.host+'/ranking-data';
        fetch(url)
            .then(response => response.json())
            .then(result => {
                
                // Ranking del usuario
                let { myRanking: {name, lastname, points, position} } = result;
                const principalUser = document.querySelector('.rankikgTables__user.active');
                principalUser.children[0].textContent = position;
                principalUser.children[1].textContent = `${name} ${lastname}`;
                principalUser.children[2].textContent = points;

                // Ranking otros users
                const containerUsers = document.querySelector('.rankikgTables__users');
                const amountRanking = result.ranking;
                let count = 0;
                amountRanking.forEach( (positionRanking:any) => {
                    console.log(positionRanking.name.split(' '));
                    
                    if(count <= 3) {
                        const newContainerUser = document.createElement('DIV');
                        newContainerUser.classList.add('rankikgTables__user', 'others');
                        newContainerUser.innerHTML =    `
                                                            <p class="posicion">${count +1}</p>
                                                            <p class="name">${positionRanking.name.split(' ')[0]} ${positionRanking.lastname.split(' ')[0]}</p>
                                                            <p class="puntaje">${positionRanking.points}</p>
                                                        `;
                        containerUsers.appendChild(newContainerUser);
                    }
                    count++;
                    
                });
                // console.log(newContainerUser);
                


                // const othersUsers:NodeListOf<HTMLElement> = document.querySelectorAll('.rankikgTables__user.others');
                
                // othersUsers.forEach( (otherUser:any) => {
                //     if(count <= 2) {
                //         let dataUser = result.ranking[count];
                        
                        
                //         otherUser.children[0].textContent = count +1;
                //         otherUser.children[1].textContent = dataUser.name === 'undefined' ? 'vacio' : `${dataUser.name} ${dataUser.lastname}`;
                //         otherUser.children[2].textContent = points;
                //         count++;
                //     }
                // })
                
            })


    } catch (error) {
        console.log(error);
    }
    
}